import { CommonModule } from '@angular/common';
import { FooterComponent } from './components/footer/footer.component';
import { GlobalDownloadsComponent } from './components/global-downloads/global-downloads.component';
import { HeaderModule } from '@modules/header/header.module';
import { LayoutComponent } from './layout.component';
import { NgModule } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SearchModule } from '@modules/search/search.module';
import { SimplebarAngularModule } from '@modules/simplebar-angular/simplebar-angular.module';
import { TopbarComponent } from './components/topbar/topbar.component';
import { TranslateModule } from '@ngx-translate/core';
import { UiModule } from '@modules/ui/ui.module';
import { environment } from '@environments/environment';
import { getDatabase } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { provideDatabase } from '@angular/fire/database';
import { provideFirebaseApp } from '@angular/fire/app';

@NgModule({
  declarations: [
    LayoutComponent,
    TopbarComponent,
    FooterComponent,
    GlobalDownloadsComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    NgbDropdownModule,
    SimplebarAngularModule,
    HeaderModule,
    SearchModule,
    UiModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideDatabase(() => getDatabase()),
  ],
})
export class LayoutModule {}
